export default "__VITE_ASSET__BXBBPHV9__"